//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectComponent from "../form/SelectComponent.vue";
import {getContentByCode} from "../../utils/utils";

export default {
  components: { SelectComponent },
  data() {
    return {
      sorting: {
        isSingle: true,
        label: '',
        selected: [],
        sorted: null
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.sorting.sorted = [
        {
          id: 0,
          name: this.getText('rel'),
          selected: false,
          code: 'default',
          order: ''
        },
        {
          id: 1,
          name: this.getText('nameaz'),
          selected: false,
          code: 'pnam',
          order: 'asc'
        },
        {
          id: 2,
          name: this.getText('nameza'),
          selected: false,
          code: 'pnam',
          order: 'desc'
        },
        {
          id: 3,
          name: this.getText('authoraz'),
          selected: false,
          code: 'author',
          order: 'asc'
        },
        {
          id: 4,
          name: this.getText('authorza'),
          selected: false,
          code: 'author',
          order: 'desc'
        },
        {
          id: 5,
          name: this.getText('periodaz'),
          selected: false,
          code: 'date',
          order: 'asc'
        },
        {
          id: 6,
          name: this.getText('periodza'),
          selected: false,
          code: 'date',
          order: 'desc'
        }
      ]

      const selectedSort = this.$route.query.sort
      const selectedOrder = this.$route.query.order

      if(selectedSort && selectedOrder) {
        this.sorting.sorted.filter(item => {
          if(item.code === selectedSort && item.order === selectedOrder) {
            this.sorting.selected.push({...item, selected: true})
            item.selected = true
          }
        })

      }
    }, 1000)
  },
  methods: {
    getText(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    },
    goToFilter (selectedList, filterType, isSingle) {
      this.sorting.selected = []
      const query = {...this.$route.query}

      if(selectedList[0].selected) {
        this.sorting.selected = [...selectedList]
        if (this.sorting.selected[0].code === 'default') {
          this.sorting.selected = []
        }
      } else {
        this.sorting.selected = []
      }

      delete query.sort
      delete query.order

      if (!this.sorting.selected.length) {
        this.$nextTick(() => {
          this.$router.push({
            path: this.$route.path,
            query
          })
        })
      } else {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...query,
            sort: this.sorting.selected[0].code,
            order:  this.sorting.selected[0].order
          }
        })
      }

    }
  },
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'sorting-texts',
        auto: true,
        params: {
          code: ['rel', 'nameaz', 'nameza', 'authoraz', 'authorza', 'periodaz', 'periodza'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  }
};
